import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const missionStatusAction = createAsyncThunk(
    'mission-status',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.patch(`/admins/api/mission-status`, { ...data })
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const missionStatusSlice = createSlice({
    name: 'mission-status',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(missionStatusAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(missionStatusAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(missionStatusAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const missionStatusReducer = missionStatusSlice.reducer    